export const getLocalDateString = (
    customDate: string | Date,
    locale: string = 'en-US',
    options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'numeric',
        timeZone: 'UTC',
        year: 'numeric'
    }
): string => {
    const date = typeof customDate === 'string' ? new Date(customDate) : customDate;

    return date.toLocaleDateString(locale, options);
};
